import {Button} from '@material-ui/core';
import {
  changeBeneficiariesFilter,
  EmptyBeneficiariesFilter,
  fetchBeneficiaries,
} from 'Beneficiaries/ducks/beneficiaries';
import {BeneficiariesRouteConstants} from 'Beneficiaries/Routes';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {ReducerState} from 'rootReducer';
import Column from 'Shared/components/PagedView/Column';
import {withStringFilterProperties} from 'Shared/components/PagedView/Filter';
import PagedView from 'Shared/components/PagedView/PagedView';
import {withValueChangedHook} from 'Shared/utilities/withValueChanged';
import './Beneficiaries.sass';

const Beneficiaries = () => {
  const dispatch = useDispatch();
  const {beneficiaries, beneficiariesFilter} = useSelector((state: ReducerState) => state.beneficiaries);

  const changeFilter = withValueChangedHook(beneficiariesFilter, changeBeneficiariesFilter, dispatch);
  const filterProperties = {
    changeFilter,
    filterData: beneficiariesFilter,
  };

  useEffect(() => {
    dispatch(changeBeneficiariesFilter(beneficiariesFilter));
  }, []);

  useEffect(() => {
    dispatch(fetchBeneficiaries(undefined, beneficiariesFilter));
  }, [beneficiariesFilter]);

  useEffect(() => {
    return () => {
      dispatch(changeBeneficiariesFilter(EmptyBeneficiariesFilter));
    };
  }, [changeBeneficiariesFilter]);

  return (
    <>
      <PagedView
        pagedViewKey="beneficiaries"
        loadMore={page => dispatch(fetchBeneficiaries(page, beneficiariesFilter))}
        data={beneficiaries}
      >
        {columnProps => (
          <>
            <Column
              {...columnProps}
              title="Policy Number"
              filterProperties={withStringFilterProperties(filterProperties, 'policyNumber')}
              default
            >
              {beneficiary => beneficiary.policyNumber}
            </Column>
            <Column
              {...columnProps}
              title="Policy Company"
              filterProperties={withStringFilterProperties(filterProperties, 'policyCompany')}
              default
            >
              {beneficiary => beneficiary.policyCompany}
            </Column>
            <Column
              {...columnProps}
              title="Policy Type"
              filterProperties={withStringFilterProperties(filterProperties, 'policyType')}
              default
            >
              {beneficiary => beneficiary.policyType}
            </Column>
            <Column
              {...columnProps}
              title="Case Number"
              filterProperties={withStringFilterProperties(filterProperties, 'caseNumber')}
              default
            >
              {beneficiary => beneficiary.caseNumber}
            </Column>
            <Column
              {...columnProps}
              title="Plan Code"
              filterProperties={withStringFilterProperties(filterProperties, 'planCode')}
              default
            >
              {beneficiary => beneficiary.planCode}
            </Column>
            <Column {...columnProps} isActions title="" default>
              {beneficiary => (
                <Link to={BeneficiariesRouteConstants.BENEFICIARY_DETAIL(beneficiary.policyNumber!)}>
                  <Button color="primary">Details</Button>
                </Link>
              )}
            </Column>
          </>
        )}
      </PagedView>
    </>
  );
};

export default Beneficiaries;
